export const SCENARIOS = { min: 'Compra mínima', vol: 'Compra por volumen', early: 'Compra anticipada', urgent: 'Compra urgente' };
export const addDays = (date, days) => {
    const parsed = new Date(`${date}T12:00:00Z`);
    parsed.setUTCDate(parsed.getUTCDate() + days);
    return parsed.toISOString().slice(0, 10);
};
export const daysBetween = (start, end) => Math.round((new Date(`${end}T12:00:00Z`) - new Date(`${start}T12:00:00Z`)) / 86400000);
export const validDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value) && Number.isFinite(Date.parse(`${value}T12:00:00Z`)) && new Date(`${value}T12:00:00Z`).toISOString().slice(0, 10) === value;
export function demandForPeriod(product, start, end, stockouts = []) {
    if (!validDate(start) || !validDate(end) || start > end || start < product.historyStart || end > product.cutoff) return { error: 'Información insuficiente: período fuera del histórico disponible.' };
    const seen = new Set();
    const clients = {};
    let sales = 0;
    product.transactions.forEach((transaction) => {
        const key = `${transaction.type}:${transaction.id}:${transaction.line}`;
        if (seen.has(key) || transaction.voided || !['Invoice', 'SalesReceipt', 'CreditMemo'].includes(transaction.type)) return;
        seen.add(key);
        if (transaction.date < start || transaction.date > end) return;
        const quantity = transaction.quantity * (transaction.type === 'CreditMemo' ? -1 : 1);
        sales += quantity;
        const client = transaction.customer || 'Sin cliente asignado';
        clients[client] = (clients[client] || 0) + quantity;
    });
    const period = daysBetween(start, end) + 1;
    const excluded = [...new Set(stockouts)].filter((date) => date >= start && date <= end).length;
    const validDays = period - excluded;
    if (validDays <= 0 || sales < 0) return { error: 'Información insuficiente: revise días válidos y devoluciones.' };
    return { sales, period, excluded, validDays, rate: sales / validDays, observedRate: sales / period, clients };
}
export function calculate(parameters, demand) {
    if (demand.error) return { error: demand.error };
    const free = Math.max(0, parameters.available - parameters.committed);
    const position = free + parameters.transit;
    const rop = demand.rate * parameters.lead + parameters.safety;
    const target = demand.rate * (parameters.lead + parameters.review) + parameters.safety;
    return { ...demand, free, position, rop, target, netNeed: Math.max(0, target - position), coverage: demand.rate > 0 ? free / demand.rate : null };
}
export function scenario(parameters, calculation, key, date) {
    if (calculation.error) return { error: calculation.error };
    if (!(parameters.units > 0)) return { error: 'Valide la Unidad de Medida para calcular conversiones y escenarios.' };
    const minimum = Math.max(parameters.min, Math.ceil(calculation.netNeed));
    const quantity = Math.ceil(key === 'vol' ? minimum * Math.max(1, parameters.volumeFactor) : minimum);
    const lead = key === 'urgent' ? parameters.urgentLead : parameters.lead;
    const advance = key === 'early' ? parameters.advance : 0;
    const orderDate = addDays(date, -advance);
    const arrivalDate = addDays(orderDate, lead);
    const remaining = Math.max(0, daysBetween(date, arrivalDate));
    const discount = key === 'vol' ? parameters.discount / 100 : 0;
    const fob = quantity * parameters.unit * (1 - discount);
    const freight = parameters.freight + (key === 'urgent' ? parameters.urgentExtra : 0);
    const total = fob + freight + parameters.insurance + parameters.tariff + parameters.inland;
    const beforeStock = Math.max(0, calculation.free - calculation.rate * remaining);
    const lost = Math.max(0, calculation.rate * remaining - calculation.free);
    const stockoutDays = calculation.rate > 0 ? Math.max(0, remaining - calculation.coverage) : null;
    const risk = calculation.coverage === null ? 'SIN CONSUMO' : calculation.coverage < remaining ? 'ALTO' : calculation.coverage < remaining + parameters.sd ? 'MEDIO' : 'BAJO';
    return { quantity, lead, remaining, orderDate, arrivalDate, advance, fob, freight, total, landed: quantity > 0 ? total / quantity : null, unitCost: quantity > 0 ? total / quantity / parameters.units : null, units: quantity * parameters.units, beforeCoverage: calculation.rate > 0 ? beforeStock / calculation.rate : null, afterCoverage: calculation.rate > 0 ? (beforeStock + quantity) / calculation.rate : null, lost, stockoutDays, risk, pastOrder: advance > 0, outdatedArrival: arrivalDate < date };
}
